/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import toastr from "toastr";

/* Import Variables */
import { isShow, usageObjectivesForPulldownByVue } from "../../variables";

/* Define Function */
const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    url: "/api/usage_objective",
    method: "GET",
    params: {},
  };

  return axiosOptions;
};

export const getUsageObjectives = async () => {
  // Get Axios Option
  const axiosOptions = await getAxiosOptions();
  await axios(axiosOptions)
    .then((result) => {
      // Set CarModel
      let usageObjectiveArray: Array<any> = [];
      $.each(result.data.data, function (index: any, value: any) {
        usageObjectiveArray.push({
          text: value.name,
          value: value.id,
        });
      });
      usageObjectivesForPulldownByVue.usageObjectives =
        usageObjectiveArray;
    })
    .catch((error) => {
      console.log(error);
      toastr.error("車種情報取得に失敗しました");
    });
};
